export class PinInfo {
  lat: number;
  lng: number;
  listingId: string;
  listPrice?: number;
  pricePerSqft?: number;
  listingDate?: Date;

  public constructor(init?: Partial<PinInfo>) {
    Object.assign(this, init);
  }
}
